import { useState } from "react"

const useFlipperFlag = name => {
  const [flippers, _setFlippers] = useState(window.flipperFlags)

  return !!flippers[name]
}

export default useFlipperFlag
